import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import appRoutes from './routerConfig';

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {
    scrollPositionRestoration: 'top', 
    anchorScrolling: 'enabled',
    scrollOffset: [0, 0],
  })],
  
  exports: [RouterModule]
})
export class AppRoutingModule { }
